(function () {
  if (window.customElements.get('cart-upsell-card')) {
    return;
  }

  class CartUpsellCard extends HTMLElement {
    connectedCallback() {
      var dataScript = this.querySelector('[data-upsell-data]');

      try {
        this.data = JSON.parse(dataScript.textContent);
      } catch (error) {
        this.data = { singleVariant: true, strings: {} };
      }

      this.trigger = this.querySelector('[data-upsell-trigger]');
      this.sheet = this.querySelector('set-drawer');
      this.addButton = this.querySelector('[data-upsell-add]');
      this.selectedVariantId = null;

      if (this.data.singleVariant) {
        this.selectedVariantId = this.data.defaultVariantId;

        if (this.trigger) {
          this.trigger.addEventListener('click', this._onDirectAdd.bind(this));
        }

        return;
      }

      this.sizeButtons = Array.prototype.slice.call(this.querySelectorAll('[data-upsell-sizes] button'));

      this.sizeButtons.forEach(function (button) {
        button.addEventListener('click', this._onSizeSelected.bind(this, button));
      }.bind(this));

      if (this.addButton) {
        this.addButton.addEventListener('click', this._onSheetAdd.bind(this));
      }
    }

    _onSizeSelected(button) {
      if (button.disabled) {
        return;
      }

      this.sizeButtons.forEach(function (other) {
        other.classList.toggle('is-active', other === button);
      });

      this.selectedVariantId = button.getAttribute('data-variant-id');

      if (this.addButton) {
        this.addButton.disabled = false;
        this.addButton.textContent = this.data.strings.add || '';
      }
    }

    _onDirectAdd(event) {
      event.preventDefault();
      this._add(this.selectedVariantId);
    }

    _onSheetAdd(event) {
      event.preventDefault();

      if (!this.selectedVariantId) {
        return;
      }

      this._add(this.selectedVariantId);
    }

    _setBusy(isBusy) {
      if (this.trigger) {
        this.trigger.disabled = isBusy;
      }

      if (this.addButton) {
        this.addButton.disabled = isBusy || !this.selectedVariantId;
      }
    }

    _add(variantId) {
      if (!variantId) {
        return;
      }

      this._setBusy(true);

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      if (this.dataset.context === 'drawer') {
        this._addInDrawer(variantId, root);
        return;
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add failed');
          }

          window.location.reload();
        })
        .catch(function () {
          this._setBusy(false);
        }.bind(this));
    }

    _addInDrawer(variantId, root) {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );

      var payload = null;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add failed');
          }
          return response.json();
        })
        .then(function (json) {
          payload = json;
          return fetch(root + 'cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          cart.sections = payload.sections;

          return this._closeSheet().then(function () {
            document.dispatchEvent(
              new CustomEvent('variant:add', {
                detail: { items: payload.items || [payload], cart: cart }
              })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              })
            );
          });
        }.bind(this))
        .catch(function () {
          this._setBusy(false);
        }.bind(this));
    }

    _closeSheet() {
      if (this.sheet && typeof this.sheet.hide === 'function' && this.sheet.hasAttribute('open')) {
        return Promise.resolve(this.sheet.hide());
      }

      return Promise.resolve();
    }
  }

  window.customElements.define('cart-upsell-card', CartUpsellCard);
})();
